<template>
  <div class="retained-view">
    <h1 class="sr-only">Retained page</h1>
    <RetainedTable data-testid="retained-table" />
  </div>
</template>

<script>
import RetainedTable from "@/v3components/Datatables/RetainedTable.vue"

export default {
  name: "Retained",
  components: { RetainedTable }
}
</script>
